import gql from 'graphql-tag';

export const GET_ALL_QUANTITY_TYPES = gql`
  query QuantityTypeFindAll(
    $where: QuantityTypeWhereInput
    $take: Int
    $skip: Int
    $orderBy: [QuantityTypeOrderByWithRelationAndSearchRelevanceInput!]
  ) {
    QuantityTypeFindAll(
      where: $where
      take: $take
      skip: $skip
      orderBy: $orderBy
    ) {
      createdAt
      createdBy
      id
      name
      quantityInM3
      isContainer
      maxPayloadTons
      FreightTypes {
        id
        name
      }
      isActive
      updatedAt
      updatedBy
    }
  }
`;

export const GET_ONE_QUANTITY_TYPE = gql`
  query QuantityTypeFindOne($where: QuantityTypeWhereUniqueInput!) {
    QuantityTypeFindOne(where: $where) {
      createdAt
      createdBy
      id
      isActive
      name
      quantityInM3
      isContainer
      maxPayloadTons
      FreightTypes {
        id
        name
      }
      updatedBy
      updatedAt
    }
  }
`;

export const CREATE_ONE_QUANTITY_TYPE = gql`
  mutation QuantityTypeCreate($data: QuantityTypeCreateInput!) {
    QuantityTypeCreate(data: $data) {
      createdAt
      createdBy
      id
      isActive
      name
      quantityInM3
      isContainer
      maxPayloadTons
      FreightTypes {
        id
        name
      }
      updatedAt
      updatedBy
    }
  }
`;

export const UPDATE_ONE_QUANTITY_TYPE = gql`
  mutation QuantityTypeUpdate(
    $data: QuantityTypeUpdateInput!
    $where: QuantityTypeWhereUniqueInput!
  ) {
    QuantityTypeUpdate(data: $data, where: $where) {
      createdAt
      createdBy
      id
      isActive
      name
      quantityInM3
      isContainer
      maxPayloadTons
      FreightTypes {
        id
        name
      }
      updatedAt
      updatedBy
    }
  }
`;

export const CONTAINER_TYPE_LINK_FREIGHT_TYPE = gql`
  mutation ContainerTypeLinkFreightType($quantityTypeId: Int!, $freightTypeId: Int!) {
    ContainerTypeLinkFreightType(
      quantityTypeId: $quantityTypeId
      freightTypeId: $freightTypeId
    ) {
      moved
      movedFromQuantityTypeId
      quantityType {
        id
        name
        FreightTypes {
          id
          name
        }
      }
      freightType {
        id
        name
        quantityTypeId
      }
    }
  }
`;
